import { toast } from "../../components/ui/use-toast";
import axios from "axios";
const baseURL = process.env.REACT_APP_SERVER_URL;
const token = localStorage.getItem("token");

export const getAllRoles = async () => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseURL}/api/roles`, config);
    return { roles: response.data.roles };
  } catch (error) {
    console.error(error);
  }
};

export const deleteUser = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.delete(`${baseURL}/api/auth/${id}`, config);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getUserById = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.get(`${baseURL}/api/auth/${id}`, config);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const updateUser = async (
  id: number,
  formData: any,
  router: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };

    const response = await axios.patch(
      `${baseURL}/api/auth/${id}`,
      formData,
      config
    );
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: "User updated ...",
      className: "bg-green-500 border border-green-500",
    });
    router("/admin-dashboard/utilisateurs");
    return response.data;
  } catch (error: any) {
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: error?.response?.data?.message,
      className: "bg-red-500 border border-red-500",
    });
  }
};
